import script from "./editAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./editAttendance.vue?vue&type=script&setup=true&lang=js"

import "./editAttendance.vue?vue&type=style&index=0&id=6f8a81b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f8a81b2"]])

export default __exports__